import { Button, Dialog, DialogContent, DialogTitle, FormControlLabel, Grid, Switch, Typography } from '@mui/material';
import { AppModels, AppState, ContactAttrs, RelatedContactAttrs, contactSelector, contactSlice, hasErrors, relatedContactSelector, relatedContactSlice, saveModel } from 'cdx-common';
import React from 'react';
import { useSelector } from 'react-redux';
import { useToaster } from '../../libraries/Toaster';
import { appStore } from '../../store';
import { ContactForm } from '../contacts/Contact';
import { ModelTextfield } from '../utils/ModelTextField';

export const EditProjectContact = (props: {
    relatedContact: RelatedContactAttrs,
    contact: ContactAttrs,
    onClose: () => void;
}) => {

    const relatedContact = useSelector((state: AppState) => relatedContactSelector.selectById(state, props.relatedContact.id));
    const contact = useSelector((state: AppState) => contactSelector.selectById(state, props.contact.id));
    const [editingRelatedContact, setEditingRelatedContact] = React.useState({ ...props.relatedContact });
    const [editingContact, setEditingContact] = React.useState({ ...props.contact });
    const { toast } = useToaster();

    React.useEffect(() => {
        setEditingRelatedContact({ ...props.relatedContact });
        setEditingContact({ ...props.contact });
    }, []);

    const update = (p: Partial<RelatedContactAttrs>) => {
        setEditingRelatedContact(curr => {
            return { ...curr, ...p };
        });
    };
    const updateContact = (p: Partial<ContactAttrs>) => {
        setEditingContact(curr => {
            return { ...curr, ...p };
        });
    };
    if (!contact || !relatedContact) return <></>;

    const onSave = async () => {
        let hasError: boolean = false;
        const relatedContactResponse = await saveModel(AppModels.relatedContacts, {
            ...editingRelatedContact
        });
        setEditingRelatedContact(relatedContactResponse);
        if (!hasErrors(relatedContactResponse)) {
            appStore.dispatch(relatedContactSlice.actions.upsertOne(relatedContactResponse));
        } else {
            hasError = true;
        }
        const contactResponse = await saveModel(AppModels.contacts, {
            ...editingContact
        });
        setEditingContact(contactResponse);
        if (!hasErrors(contactResponse)) {
            appStore.dispatch(contactSlice.actions.upsertOne(contactResponse));
        } else {
            hasError = true;
        }
        if (hasError) {
            toast.error('Error de sauvegarde');
        } else {
            props.onClose();
        }
    };

    return <Dialog open={true} onClose={props.onClose}>
        <DialogTitle>Fiche {contact.name}</DialogTitle>
        <DialogContent>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant='h5' gutterBottom>Pour ce projet</Typography>
                </Grid>
                <Grid item xs={12}>
                    <ModelTextfield
                        fullWidth
                        size='small'
                        model={editingRelatedContact}
                        modelType={AppModels.relatedContacts}
                        placeholder={editingRelatedContact.label ?? ''}
                        row='label'
                        onChange={event => update({ label: event.target.value })}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel control={<Switch checked={editingRelatedContact.onSiteContact === true} onChange={() => {
                        update({ onSiteContact: !editingRelatedContact.onSiteContact });
                    }} />} label="Contact de chantier" />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant='h5' gutterBottom>Fiche de contact</Typography>
                </Grid>
            </Grid>
            <ContactForm contact={editingContact} update={updateContact} compact />
            <Grid container marginTop={3}>
                <Grid item xs={12}>
                    <Button onClick={onSave} variant='contained'>Sauvegarder</Button>
                    <Button onClick={props.onClose}>Annuler</Button>
                </Grid>
            </Grid>
        </DialogContent>
    </Dialog>;
};
